const r=globalThis.atob;export default function f(e){e=r(e);const t=new ArrayBuffer(e.length),o=new Uint8Array(t);for(let n=0,a=e.length;n<a;n++)o[n]=e.charCodeAt(n);return t}
//# sourceMappingURL=str2ab.js.map
